/**
 * 滚动到底部
 * @param el 滚动的元素
 * @param smooth 是否平滑滚动
 */
export function scrollToBottom(el: HTMLElement | null, smooth = true) {
  if (!el) return;
  el.style.scrollBehavior = smooth ? 'smooth' : 'auto';
  el.scrollTop = el.scrollHeight;
}

export function scrollToTop(el: HTMLElement | null, smooth = true) {
  if (!el) return;
  el.style.scrollBehavior = smooth ? 'smooth' : 'auto';
  el.scrollTop = 0;
}
